import React from 'react';

export default function Badge({ text, color, bg, size }) {
  return (
    <span style={{
      fontSize: size || 11, fontWeight: 600,
      color: color || '#6B7280',
      background: bg || '#F3F4F6',
      padding: '2px 7px', borderRadius: 4,
      whiteSpace: 'nowrap', display: 'inline-block',
    }}>
      {text}
    </span>
  );
}
